import React, { useState, useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import {
  MRRCard,
  ClientsCard,
  TodayTasksCard,
  PipelineCard,
  RecentActivityCard,
  QuickAddLeadCard,
  BillingAlertCard,
  ActiveLeadsCard,
} from '../components/dashboard';
import { LoadingSpinner } from '../components/common';
import { useApp } from '../context/AppContext';
import { leadApi, activityApi } from '../services/api';

const Dashboard = () => {
  const { settings, fetchDashboardData, dashboardData } = useApp();
  const [tasks, setTasks] = useState(null);
  const [activities, setActivities] = useState([]);
  const [pipeline, setPipeline] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const [tasksRes, activitiesRes, pipelineRes] = await Promise.all([
        leadApi.getTodayTasks(),
        activityApi.getRecent(10),
        leadApi.getPipeline(),
      ]);

      setTasks(tasksRes.data);
      setActivities(activitiesRes.data);
      setPipeline(pipelineRes.data);
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchDashboardData();
  }, [fetchDashboardData]);

  const handleLeadAdded = () => {
    fetchData();
    fetchDashboardData();
  };

  if (loading) {
    return <LoadingSpinner message="Loading dashboard..." />;
  }

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Top Row - Key Metrics */}
        <Grid item xs={12} md={6} lg={4}>
          <MRRCard
            data={dashboardData?.mrr}
            goal={settings?.mrrGoal || 2000}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <ClientsCard
            data={dashboardData?.clients}
            goal={settings?.clientGoal || 50}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <BillingAlertCard />
        </Grid>

        {/* Active Leads - Pitch Site Visitors */}
        <Grid item xs={12}>
          <ActiveLeadsCard />
        </Grid>

        {/* Quick Add Lead */}
        <Grid item xs={12}>
          <QuickAddLeadCard onLeadAdded={handleLeadAdded} />
        </Grid>

        {/* Middle Row - Tasks and Pipeline */}
        <Grid item xs={12} lg={6}>
          <TodayTasksCard tasks={tasks} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <PipelineCard data={pipeline} />
        </Grid>

        {/* Bottom Row - Recent Activity */}
        <Grid item xs={12}>
          <RecentActivityCard activities={activities} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
